<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw BookTitlePage-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<div class="title-block-book-rw" id="title-block-book1">
<h1 epub:type="fulltitle" id="h11">Last True Hero</h1>
<p class="title-sub-rw" epub:type="subtitle" id="title-sub1">Honor &amp; Valor</p>
<p class="title-author-rw" id="title-author1">Diana Gardin</p>
</div>
<div class="imprint-rw" epub:type="imprint">
<p id="p1"><img alt="alt" src="images/Forever_Yours_Red_Logo.png"/></p>
<p id="p2">New York</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s001-BookTitlePage-01.vue?70f00d1c